import { TSwitcherPeriod } from 'components/base/DateRange/PeriodSwitcher';
import { Moment } from 'moment';
import { createContext } from 'react';

const noop = (): void => {}; // eslint-disable-line @typescript-eslint/no-empty-function
export interface IDateRangeContext {
  withPeriod?: boolean;
  datePeriod?: TSwitcherPeriod;
  minDate?: Moment;
  maxDate?: Moment;
  onSelectDate: (date: Moment) => void;
  onHoverDate: (date: Moment) => void;
  hoverDate: Moment | null;
}

export const DateRangeContext = createContext<IDateRangeContext>({
  withPeriod: false,
  datePeriod: undefined,
  minDate: undefined,
  maxDate: undefined,
  onSelectDate: noop,
  onHoverDate: noop,
  hoverDate: null,
});
